const exactMap: Record<string, string> = {
  'Brak autoryzacji': 'Missing authorization',
  'Sesja wygasła': 'Session expired',
  'Sesja wygasla': 'Session expired',
  'Brak ID playlisty': 'Missing playlist ID',
  'Brak dostępu do playlisty': 'No access to playlist',
  'Brak dostepu do playlisty': 'No access to playlist',
  'Brak dostępu': 'No access',
  'Brak dostepu': 'No access',
  'Playlista zduplikowana': 'Playlist duplicated',
  'Blad podczas duplikowania playlisty': 'Failed to duplicate playlist',
  'Błąd podczas duplikowania playlisty': 'Failed to duplicate playlist',
  'Playlista usunięta': 'Playlist deleted',
  'Nazwa nie uległa zmianie': 'Name has not changed',
  'Źródło usunięte': 'Source removed',
  'Źródło zaktualizowane': 'Source updated',
  'Połączenie udane': 'Connection successful',
  'Wylogowano pomyślnie': 'Logged out successfully',
  'Zalogowano pomyślnie': 'Logged in successfully',
  'Rejestracja zakończona pomyślnie': 'Registration completed successfully',
  'Jeśli konto z tym adresem istnieje, wysłaliśmy instrukcje resetu hasła.':
    'If an account exists for this email, we sent password reset instructions.',
  'Link resetu jest nieprawidłowy lub wygasł': 'Reset link is invalid or has expired',
  'Hasło zostało zmienione. Możesz się zalogować.': 'Password changed. You can sign in.',
  'Brak lub nieprawidłowy token resetu': 'Missing or invalid reset token',
};

function replaceDynamic(message: string): string {
  let out = message;
  out = out.replace(/^Błąd bazy danych:\s*/i, 'Database error: ');
  out = out.replace(/^Błąd zapisu do bazy:\s*/i, 'Database save error: ');
  out = out.replace(/^Błąd bazy:\s*/i, 'Database error: ');
  out = out.replace(/^Nie udało się\s*/i, 'Failed to ');
  out = out.replace(/^Nie udalo sie\s*/i, 'Failed to ');
  out = out.replace(/^Nieprawidłowe\s*/i, 'Invalid ');
  out = out.replace(/^Nieprawidlowe\s*/i, 'Invalid ');
  out = out.replace(/^Brak wymaganych pól/i, 'Missing required fields');
  out = out.replace(/^Brak wymaganych pol/i, 'Missing required fields');
  out = out.replace(/^Brak ID źródła$/i, 'Missing source ID');
  out = out.replace(/^Brak ID zrodla$/i, 'Missing source ID');
  out = out.replace(/^Brak ID kanału$/i, 'Missing channel ID');
  out = out.replace(/^Brak ID kanalu$/i, 'Missing channel ID');
  out = out.replace(/^Kanał nie znaleziony$/i, 'Channel not found');
  out = out.replace(/^Kolejność zapisana$/i, 'Order saved');
  out = out.replace(/^Nie znaleziono kanałów w pliku M3U$/i, 'No channels found in M3U file');
  out = out.replace(/^Nie znaleziono kanałów w pliku\.$/i, 'No channels found in file.');
  out = out.replace(/^Nie znaleziono kanałów w pliku$/i, 'No channels found in file');
  out = out.replace(/^Źródła krajowe nie mogą być usuwane$/i, 'Country sources cannot be deleted');
  out = out.replace(/^Zródła krajowe nie mogą być usuwane$/i, 'Country sources cannot be deleted');
  return out;
}

export function toEnglishUserMessage(message: string): string {
  const normalized = String(message ?? '').trim();
  if (!normalized) return normalized;
  if (exactMap[normalized]) return exactMap[normalized];
  return replaceDynamic(normalized);
}
